import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import BonusXLoading from "../../../../legacy/components/BonusXLoading";
import { useNextUrlRedirectGuard } from "../hooks/useNextUrlRedirectGuard";

interface NextUrlRedirectGuardProps {
  readonly children: ReactNode;
}

const forceDefaultBackNavigationState = {
  isDirectAccess: true,
};

export function NextUrlRedirectGuard(props: NextUrlRedirectGuardProps): JSX.Element {
  const { children } = props;
  const { loading, redirectTo } = useNextUrlRedirectGuard();

  if (loading) {
    return <BonusXLoading />;
  }

  if (redirectTo !== null) {
    return <Navigate to={redirectTo} replace state={forceDefaultBackNavigationState} />;
  }

  return <>{children}</>;
}

export default NextUrlRedirectGuard;
